import BeforeandAfter from '../../assets/BeforeandAfter.png'; // with import
import Communication from '../../assets/Communication.png';
import ExploringLife from '../../assets/ExploringLife.png';
import Kiddiepreneur101 from '../../assets/Kiddiepreneur101.png';
import MathsmaniaCity from '../../assets/MathsmaniaCity-Decimal.png';
import MathsPop from '../../assets/MathsPop.png';
import MoneyMatters from '../../assets/MoneyMatters.png';

const GAME_DATA = [
  {
    GameTitle: 'Before and After',
    GameDescription: 'Before and After Yr 2 (prefix and suffix)',
    Topic: 'Word Works and Spelling',
    Group: 'Academic',
    Level: 'Key Stage 1',
    Subject: 'English',
    GameImage: BeforeandAfter,
  },
  {
    GameTitle: 'Communication',
    GameDescription: 'Communication Yr 2 (different ways we can communicate)',
    Topic: 'Social Studies',
    Group: 'Academic',
    Level: 'Key Stage 1',
    Subject: 'Social Studies',
    GameImage: Communication,
  },
  {
    GameTitle: 'Kiddiepreneur 101',
    GameDescription: 'Kiddiepreneur 101 (Intro to Earning and Spending)',
    Topic: 'Financial Literacy',
    Group: 'Financial Literacy',
    Level: 'Financial Literacy',
    Subject: 'Financial Literacy',
    GameImage: Kiddiepreneur101,
  },
  {
    GameTitle: 'Money Matters',
    GameDescription: 'Money Matters (Intro to Key Financial Terms)',
    Topic: 'Financial Literacy',
    Group: 'Financial Literacy',
    Level: 'Financial Literacy',
    Subject: 'Financial Literacy',
    GameImage: MoneyMatters,
  },
  {
    GameTitle: 'Maths Pop',
    GameDescription:
      'Maths Pop (writing numbers in word, sequencing & ordinal numbers)',
    Topic: 'Number Sense',
    Group: 'Academic',
    Level: 'Key Stage 1',
    Subject: 'Mathematics',
    GameImage: MoneyMatters,
  },
  {
    GameTitle: 'Exploring Life',
    GameDescription: 'Exploring Life KS',
    Topic: 'Living Things & Non-Living Things',
    Group: 'Academic',
    Level: 'Key Stage 1',
    Subject: 'Science',
    GameImage: ExploringLife,
  },
  {
    GameTitle: 'Mathsmania City - Decimals',
    GameDescription: 'Mathsmania City - Decimal',
    Topic: 'Decimals, Fractions & Percentage',
    Group: 'Academic',
    Level: 'Key Stage 2',
    Subject: 'Mathematics',
    GameImage: MathsmaniaCity,
  },
];

export default GAME_DATA;
